export const topScroll = () => {
    window.scrollTo({
        top: 0,    // Vertical position in pixels
        left: 0,     // Horizontal position in pixels
        behavior: 'smooth' // Optional: "smooth" or "auto" scrolling
    });
}